<template>
  <div class="collapse" v-if="!isHide">
    <div
      class="hd"
      :class="{
        fold: !configMainShow['bigData'],
      }"
      @click="configMainShow['bigData'] = !configMainShow['bigData']"
    >
      <div class="title-fix">
        <i class="fa-angle-down"></i>
        <span>大数据</span>
        <span class="el-switch" @click.stop="toggleEnable('bigData', '大数据')">
          <el-switch v-model="configure.bigData.enable" disabled></el-switch>
        </span>
      </div>
    </div>
    <div
      class="bd"
      @click="
        isNaN(featureList['bigData'].timeRemaining)
          ? shoWDialogBuy(
              featureList['bigData']['productKey'],
              '大数据',
              'bigData'
            )
          : featureList['bigData'].timeRemaining <= 0
          ? showFunctionalRenewal(true)
          : configure.bigData.enable
          ? ''
          : toggleEnable('bigData', '大数据')
      "
      :class="{
        'no-buy': isNaN(featureList['bigData'].timeRemaining),
        expired: featureList['bigData'].timeRemaining <= 0,
        'shut-off': !configure.bigData.enable,
      }"
    >
      <el-row>
        <el-col :span="5"> 记录查询 </el-col>
        <el-col :span="19">
          <div class="big-data-form">
            <div class="form-header">
              <el-input
                placeholder="搜用户昵称"
                v-model="nameText"
                class="input-with-select"
                size="medium"
                @input="searchInput"
                @keyup.enter.native="querySearch"
                @focus="searchFocus"
              >
                <el-select
                  v-model="roomSel"
                  slot="prepend"
                  placeholder="选择直播间"
                  size="mini"
                >
                  <el-option
                    v-for="item in liveHistoryList"
                    :key="item.room_id"
                    :label="item.nickname"
                    :value="item.room_id"
                  ></el-option>
                </el-select>
              </el-input>
              <div class="btn-box">
                <!-- <el-button
                  size="medium"
                  type="primary"
                  @click="checkResult('danmu')"
                  >查弹幕</el-button
                > -->
                <el-button
                  size="medium"
                  type="primary"
                  @click="checkResult('gift')"
                  >查礼物</el-button
                >
              </div>
              <div
                class="search-content"
                :class="{
                  show: isShowSearchContent,
                }"
                v-loading="isLoadingOfSearch"
              >
                <person-card
                  v-for="item in searchKeyPesonList"
                  :key="item.uid"
                  :user="item"
                  @cardClick="personSel(item)"
                ></person-card>
              </div>
            </div>
            <div class="form-time-tab">
              <div class="desc">记录列表（场控工作时才会产生数据）</div>
              <el-radio-group v-model="time" size="mini">
                <el-radio-button label="today">今天</el-radio-button>
                <el-radio-button label="yesterday">昨日</el-radio-button>
                <!-- <el-radio-button label="week">近7天</el-radio-button> -->
                <el-radio-button label="other">
                  {{ customTimeText ? customTimeText : "日期" }}
                  <el-date-picker
                    ref="customTime"
                    v-model="customTime"
                    :picker-options="pickerOptions"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    @focus="datePickerFocus"
                    :clearable="false"
                  >
                  </el-date-picker
                ></el-radio-button>
              </el-radio-group>
            </div>
            <div class="form-body" v-loading="isLoading">
              <ul
                class="danmu-list"
                v-show="danmuList.length && dataType == 'danmu'"
              >
                <li v-for="(item, index) in danmuList" :key="index">
                  <div class="user-info" v-if="searchUser">
                    <span
                      class="noble-icon"
                      :class="`noble-level-${searchUser.noble_level}`"
                    ></span>
                    <span class="name">{{ searchUser.nickname }}</span>
                    <span
                      class="level-icon"
                      :class="`level-icon${searchUser.level}`"
                    ></span>
                  </div>
                  <div class="danmu-info">{{ item.danmu }}</div>
                  <div class="data-time">
                    {{ item.time }}
                  </div>
                </li>
              </ul>
              <ul
                class="gift-list"
                v-show="giftList.length && dataType == 'gift'"
              >
                <li v-for="(item, index) in giftList" :key="index">
                  <div class="user-info" v-if="searchUser">
                    <span
                      class="noble-icon"
                      :class="`noble-level-${searchUser.noble_level}`"
                    ></span>
                    <span class="name">{{ searchUser.nickname }}</span>
                    <span
                      class="level-icon"
                      :class="`level-icon${searchUser.level}`"
                    ></span>
                  </div>
                  <div class="gift-info">
                    {{ item.name }}
                    <img :src="item.icon" alt="" />
                    <span>x{{ item.count }}</span>
                  </div>
                  <div class="data-time">
                    {{ new Date(item.sent_at).pattern("MM-dd HH:mm") }}
                  </div>
                </li>
              </ul>
              <div
                class="no-data"
                v-show="!danmuList.length && !giftList.length"
              >
                暂无数据
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row>
        <el-col :span="5">辅助增强</el-col>
        <el-col :span="19">
          <div class="row-padding big-data-fuc-desc">
            「来宾欢迎」增加“消费档暗号”功能。<a href="#welcomeBigData"
              ><i class="fa-sign-in"></i
            ></a>
            <q> 进场贵宾的近期消费能力，偷偷用暗号告诉你 </q>
          </div>
          <div class="row-padding big-data-fuc-desc">
            「大哥名单」增加按“近期消费能力”自动加入大哥名单功能。<a
              href="#keyPersonBigData"
              ><i class="fa-sign-in"></i
            ></a>
            <q> 支持根据近期消费能力，自动把用户加入大哥名单 </q>
          </div>
          <!-- <div class="row-padding big-data-fuc-desc">
            「智能狗」增加按“近期消费能力”优选目标功能。<a
              href="#begGiftBigData"
              ><i class="fa-sign-in"></i
            ></a>
            <q>
              根据用户兜里金豆券余额优选狗礼物对象
            </q>
          </div>
          <div class="row-padding big-data-fuc-desc">
            「私信作业」增加按“近期消费能力”发进场私信功能。<a
              href="#privateLetterBigData"
              ><i class="fa-sign-in"></i
            ></a>
            <q>
              支持给近期消费能力大于一定值的人写作业
            </q>
          </div> -->
        </el-col>
      </el-row>
      <div class="reset-row">
        <el-button
          type="danger"
          size="small"
          @click="resetDefault('大数据', 'bigData')"
          >「大数据」恢复默认</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  getLiveHistoryList,
  getLiveHistoryChatList,
  getLiveHistoryGiftList,
  searchKeyPerson,
} from "@/api/index";
import { configCommon } from "@/mixins/configCommon";
import { commonFuc } from "@/mixins/commonFuc";
import personCard from "@/components/personCard";

export default {
  mixins: [configCommon, commonFuc],
  data() {
    return {
      nameText: "",
      personId: "",
      roomSel: "",
      time: "today",
      customTime: new Date(),
      dataType: "danmu",
      searchUser: null,
      danmuList: [
        // {
        //   nobel: 1,
        //   nickname: "阿呆",
        //   level: 12,
        //   danmu:
        //     "叽里呱啦叽里呱啦叽里呱啦叽里呱啦叽里呱啦叽里呱啦叽里呱啦叽里呱啦",
        //   time: "6-20 14:22",
        // },
      ],
      giftList: [
        // {
        //   nobel: 1,
        //   nickname: "阿呆",
        //   level: 12,
        //   giftName: "粉丝票",
        //   giftCount: 10,
        //   time: "6-20 14:22",
        // },
      ],
      liveHistoryList: [],
      searchKeyPersonTimer: null,
      isShowSearchContent: false,
      searchKeyPesonList: [],
      isLoading: false,
      isLoadingOfSearch: false,
      pickerOptions: {
        disabledDate: (time) => {
          let timeOptionRange = new Date();
          let seven = 3600 * 1000 * 24 * 7;
          if (timeOptionRange) {
            // /*选择的日期 与 当前日期 小于7天*/
            let current =
              new Date(new Date().toLocaleDateString()) -
              timeOptionRange.getTime();
            return (
              time.getTime() >
                timeOptionRange.getTime() +
                  (current < seven ? current : seven) ||
              time.getTime() < timeOptionRange.getTime() - seven
            );
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      cookie: "",
    };
  },
  props: {
    configure: {
      type: Object,
      default: null,
    },
    featureList: {
      type: Object,
      default: null,
    },
    ticket: {
      type: String,
      default: "",
    },
    configMainShow: {
      type: Object,
      default: () => {
        return {
          account: true,
          welcome: true,
          giftTks: true,
          guide: true,
          bigData: true,
          AIChat: true,
          readText: true,
          autoBan: true,
          keyPerson: true,
          begGift: true,
          guessNum: true,
          duty: true,
          global: true,
        };
      },
    },
  },
  components: {
    personCard,
  },
  computed: {
    customTimeText() {
      return new Date(this.customTime).pattern("MM-dd");
    },
    isHide() {
      let time = this.featureList["bigData"].timeRemaining;
      if (isNaN(time) || time <= 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    time(val) {
      console.log(val);
    },
  },
  mounted() {
    this.getLiveHistoryList();
    let accountList = localStorage["accountList"]
      ? JSON.parse(localStorage["accountList"])
      : {};
    if (
      accountList[this.$route.query.ticket] &&
      !this.isAccountExpire(accountList[this.$route.query.ticket].timestamp)
    ) {
      this.cookie = accountList[this.$route.query.ticket].cookies;
    }
  },
  methods: {
    isAccountExpire(timestamp) {
      // let r = await new Promise((res) => {
      //     setTimeout(() => { res() }, 0);
      // });
      let timeStamp = parseInt((+new Date() - timestamp) / 86400000) >= 7;
      if (timeStamp) {
        return true;
      } else {
        return false;
      }
    },
    getLiveHistoryList() {
      getLiveHistoryList({
        ticket: this.ticket,
      }).then((res) => {
        if (res.code == 0) {
          this.liveHistoryList = res.data.list;
        }
      });
    },
    checkResult(type) {
      let dateBegin = new Date();
      let dateEnd = new Date();
      if (this.time == "yesterday") {
        dateBegin = new Date(new Date().getTime() - 3600 * 1000 * 24 * 1);
        dateEnd = new Date(new Date().getTime() - 3600 * 1000 * 24 * 1);
        console.log(dateBegin, dateEnd);
      }
      if (this.time == "week") {
        dateBegin = new Date(new Date().getTime() - 3600 * 1000 * 24 * 7);
        dateEnd = new Date(new Date());
      }
      if (this.time == "other") {
        dateBegin = new Date(this.customTime);
        dateEnd = new Date(this.customTime);
      }
      this.dataType = type;
      if (!this.roomSel) {
        this.$message.error("请选择需要搜索的房间");
        return;
      }
      if (!this.personId) {
        this.$message.error("请选择需要搜索的用户昵称");
        this.querySearch(this.nameText);
        return;
      }
      if (type == "gift") {
        this.getLiveHistoryGiftList(dateBegin, dateEnd);
      }
      if (type == "danmu") {
        this.getLiveHistoryChatList(dateBegin, dateEnd);
      }
    },
    getLiveHistoryChatList(dateBegin, dateEnd) {
      getLiveHistoryChatList({
        ticket: this.ticket,
        room_id: this.roomSel,
        code: this.personId,
        date_begin: dateBegin.format(),
        date_end: dateEnd.format(),
      }).then((res) => {
        if (res.code == 0) {
          this.searchUser = res.data.user;
          this.danmuList = res.data.list;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
          this.searchUser = null;
          this.danmuList = [];
        }
      });
    },
    getLiveHistoryGiftList(dateBegin, dateEnd) {
      this.giftList = [];
      this.isLoading = true;
      getLiveHistoryGiftList({
        ticket: this.ticket,
        room_id: this.roomSel,
        code: this.personId,
        date_begin: dateBegin.format(),
        date_end: dateEnd.format(),
      }).then((res) => {
        if (res.code == 0) {
          this.searchUser = res.data.user;
          this.giftList = res.data.list;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
          this.searchUser = null;
          this.giftList = [];
        }
        this.isLoading = false;
      });
    },
    datePickerFocus() {
      this.time = "other";
    },
    querySearch(queryString, cb) {
      this.isLoadingOfSearch = true;
      this.searchKeyPesonList = [];
      this.isShowSearchContent = true;
      if (!this.nameText) {
        this.searchKeyPesonList = [];
        this.isShowSearchContent = false;
        this.$message.warning("请输入要搜索的用户昵称或者虎牙号");
        return;
      }
      if (this.nameText.length) {
        // clearTimeout(this.searchKeyPersonTimer);
        // this.searchKeyPersonTimer = setTimeout(() => {
        searchKeyPerson({
          keywords: this.nameText,
          ticket: this.ticket,
          cookie: this.cookie,
        }).then((res) => {
          if (res.code == 0) {
            if (res.data.result.length) {
              if (res.data.result.length == 1) {
                this.personSel(res.data.result[0]);
              } else {
                this.searchKeyPesonList = res.data.result;
              }
            } else {
              this.searchKeyPesonList = [];
              this.isShowSearchContent = false;
              this.$message.error("该用户并未入库");
            }
          } else {
            this.searchKeyPesonList = [];
            this.isShowSearchContent = false;
          }
          this.isLoadingOfSearch = false;
        });
        // }, 1e3);
      } else {
        this.searchKeyPesonList = [];
      }
    },
    searchFocus() {
      if (this.searchKeyPesonList.length && this.nameText.length) {
        this.isShowSearchContent = true;
      }
    },
    searchInput() {
      if (this.searchKeyPesonList.length && !this.nameText.length) {
        this.isShowSearchContent = false;
      }
    },
    personSel(item) {
      this.personId = item.uid;
      this.nameText = item.nickname;
      this.isShowSearchContent = false;
    },
  },
};
</script>

<style lang="less">
.big-data-form {
  position: relative;
  .form-header {
    display: flex;
    .input-with-select {
      flex: 2;
      .el-input-group__prepend {
        background: #fff;
        padding: 0;
        .el-select {
          margin: 0;
        }
      }
    }
    .btn-box {
      display: flex;
      .el-button {
        width: 80px;
        margin-left: 5px;
      }
    }
    .search-content {
      width: calc(~"100% - 85px");
      top: 36px;
      @media (max-width: 600px) {
        width: 100%;
      }
    }
  }
  .form-time-tab {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0;
    white-space: nowrap;
    .desc {
      font-size: 14px;
    }
    .el-date-editor.el-input {
      position: absolute;
      opacity: 0;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      .el-input__inner {
        width: 100%;
        height: 100%;
        padding: 0;
        cursor: pointer;
      }
    }
  }
  .form-body {
    position: relative;
    height: 350px;
    overflow: auto;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    li {
      display: flex;
      justify-content: space-between;
      align-items: top;
      padding: 10px 10px 0 10px;
      .user-info {
        font-size: 16px;
        .name {
          color: #ba9455;
          margin: 0 5px;
          max-width: 100px;
          vertical-align: middle;
        }
      }
      .danmu-info,
      .gift-info {
        flex: 1;
        margin: 0 10px;
      }
      .gift-info {
        img {
          width: 20px;
          vertical-align: text-bottom;
          margin: 0 5px;
        }
        span {
          color: #ff9a2f;
        }
      }
      .data-time {
        color: #ba9455;
      }
    }
    .no-data {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 16px;
      color: #000;
    }
  }
  @media (max-width: 960px) {
    .form-header,
    .form-time-tab {
      display: block;
    }
    .form-header {
      .input-with-select {
        margin-bottom: 10px;
      }
      .btn-box {
        .el-button {
          margin-left: 0;
          & + .el-button {
            margin-left: 5px;
          }
        }
      }
    }
    .form-time-tab {
      .desc {
        margin-bottom: 5px;
      }
    }
  }
}
.big-data-fuc-desc {
  font-size: 14px;
  .fa-sign-in {
    font-size: 20px;
    margin-left: 10px;
    color: #21a0ff;
    vertical-align: text-bottom;
    cursor: pointer;
  }
}
</style>
